<template>
  <v-main class="fill-height pa-2 idcs-main-list">
    <v-row align="center" align-content="center">
      <v-col cols="2" sm="6" md="2" lg="2">
        <v-select v-model="filter.type_" :items="$t('evt.type')" :label="$t('fields.type')"></v-select>
      </v-col>
      <v-col cols="3" sm="6" md="2" lg="2">
        <v-text-field v-model="filter.ip" :label="$t('fields.ip')"></v-text-field>
      </v-col>
      <v-col cols="3" sm="6" md="2" lg="2">
        <v-text-field v-model="filter.path_" :label="$t('fields.path')"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3">
        <DateRange v-model="dates" @apply="loadData" @cancel="loadData" />
      </v-col>
      <v-col cols="3" sm="6" md="3" lg="3">
        <v-text-field
          v-model="filter.pattern"
          :label="$t('fields.detail')"
          append-outer-icon="mdi-magnify"
          @click:append-outer="loadData"
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="1" class="text-right">
        <v-btn icon @click="loadData">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>-->
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagination"
      :page.sync="currentPage"
      item-key="idx"
      class="transparent mx-2 table-custom"
      :items-per-page.sync="itemPerPage"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
      show-expand
      :server-items-length="totalItems"
    >
      <template v-slot:item.type="{item}">{{$t("evt.type")[item.type+1].text}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template
        v-slot:item.name="{item}"
      >{{item.user_?item.user_:(item.posUser?item.posUser:item.webPosUser)}}</template>
      <template v-slot:expanded-item="{item, headers}">
        <td v-if="item.detail" :colspan="headers.length">
          <v-row>
            <v-col v-for="(v,k) in item.detail" :key="k">
              <div>{{k}}</div>
              <div>{{v}}</div>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </v-main>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import DateRange from "@/components/DateRange.vue";

export default {
  name: "Events",
  mixins: [commonmixin],
  components: { DateRange },
  data() {
    return {
      filter: {
        type_: "",
        ip: "",
        path_: "",
        pattern: "",
      },
      dates: [],
      totalItems: 0,
      headers: [
        {
          text: this.$t("fields.type"),
          value: "type",
        },
        {
          text: this.$t("fields.created"),
          value: "created",
        },
        {
          text: this.$t("fields.path"),
          value: "path",
        },
        {
          text: this.$t("fields.ip"),
          value: "ip",
        },
        {
          text: this.$t("fields.name"),
          value: "name",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    pagination: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },

  methods: {
    loadData() {
      this.$api
        .getEvents({
          sortBy: this.pagination.sortBy,
          sortDesc: this.pagination.sortDesc,
          filter: { ...this.filter, dates: this.dates },
          limit: this.pagination.itemsPerPage,
          offset: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        })
        .then((r) => {
          this.totalItems = r.total;
          this.items = r.items;
        });
    },
  },
  mounted() {
    //this.loadData();
  },
};
</script>

<style>
</style>